<script setup lang="ts">
import { computed, useSlots } from "vue"

const props = withDefaults(
  defineProps<{
    countLabel?: string
    dirty?: boolean
    layout?: "default" | "balanced"
  }>(),
  {
    countLabel: "",
    dirty: false,
    layout: "default"
  }
)
const emit = defineEmits<{
  reset: []
}>()

const slots = useSlots()
const hasSearchSlot = computed(() => Boolean(slots.search))
const hasFiltersSlot = computed(() => Boolean(slots.filters || slots.default))
const filterIcon = computed(() => (props.dirty ? "i-ph-funnel-simple-x" : "i-ph-funnel-simple"))
const filterLabel = computed(() => (props.dirty ? "Clear filters" : props.countLabel || "Filters"))
</script>

<template>
  <section
    class="dashboard-filter-bar dashboard-section flex min-w-0 max-w-full flex-col gap-3 p-3 lg:flex-row lg:items-center"
    :data-layout="layout"
  >
    <div class="dashboard-filter-leading">
      <slot name="leading">
        <UButton
          color="neutral"
          variant="ghost"
          size="xs"
          square
          :disabled="!dirty"
          :icon="filterIcon"
          :aria-label="filterLabel"
          :title="filterLabel"
          class="dashboard-filter-toggle"
          :ui="{ base: 'justify-center p-0', leadingIcon: 'dashboard-filter-toggle-icon' }"
          @click="emit('reset')"
        />
      </slot>
    </div>
    <div v-if="hasSearchSlot" class="dashboard-filter-search-slot">
      <slot name="search" />
    </div>
    <div v-if="hasFiltersSlot" class="dashboard-filter-filters-slot">
      <slot name="filters">
        <slot />
      </slot>
    </div>
  </section>
</template>
